 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXTCOVER from '@/components/text/Cover'
 import LOVE_1 from '@/components/love_1'
 import TEXTTITLE from '@/components/text/Title'
 import TEXTCOPYRIGHT from '@/components/text/Copyright'
 import TEXTDEDICATION from '@/components/text/Dedication'
 import TEXTCONTENTS from '@/components/text/Contents'
 import TEXTINTRODUCTION from '@/components/text/Introduction'
 import TEXTCHAPTER001 from '@/components/text/Chapter001'
 import TEXTCHAPTER002 from '@/components/text/Chapter002'
 import TEXTCHAPTER003 from '@/components/text/Chapter003'
 import TEXTCHAPTER004 from '@/components/text/Chapter004'
 import TEXTCHAPTER005 from '@/components/text/Chapter005'
 import TEXTCHAPTER006 from '@/components/text/Chapter006'
 import TEXTCHAPTER006SEC1 from '@/components/text/Chapter006sec1'
 import TEXTCHAPTER006SEC2 from '@/components/text/Chapter006sec2'
 import TEXTCHAPTER006SEC3 from '@/components/text/Chapter006sec3'
 import TEXTCHAPTER006SEC4 from '@/components/text/Chapter006sec4'
 import TEXTCHAPTER006SEC5 from '@/components/text/Chapter006sec5'
 import TEXTCHAPTER006SEC6 from '@/components/text/Chapter006sec6'
 import TEXTCHAPTER006SEC7 from '@/components/text/Chapter006sec7'
 import TEXTCHAPTER006SEC8 from '@/components/text/Chapter006sec8'
 import TEXTCHAPTER006SEC9 from '@/components/text/Chapter006sec9'
 import TEXTCHAPTER006SEC10 from '@/components/text/Chapter006sec10'
 import TEXTCHAPTER006SEC11 from '@/components/text/Chapter006sec11'
 import TEXTCHAPTER006SEC12 from '@/components/text/Chapter006sec12'
 import TEXTCHAPTER006SEC13 from '@/components/text/Chapter006sec13'
 import TEXTCHAPTER006SEC14 from '@/components/text/Chapter006sec14'
 import TEXTCHAPTER006SEC15 from '@/components/text/Chapter006sec15'
 import TEXTCHAPTER006SEC16 from '@/components/text/Chapter006sec16'
 import TEXTCHAPTER006SEC17 from '@/components/text/Chapter006sec17'
 import TEXTCHAPTER006SEC18 from '@/components/text/Chapter006sec18'
 import TEXTCHAPTER006SEC19 from '@/components/text/Chapter006sec19'
 import TEXTCHAPTER006SEC20 from '@/components/text/Chapter006sec20'
 import TEXTCHAPTER006SEC21 from '@/components/text/Chapter006sec21'
 import TEXTCHAPTER006SEC22 from '@/components/text/Chapter006sec22'
 import TEXTCHAPTER006SEC23 from '@/components/text/Chapter006sec23'
 import TEXTCHAPTER006SEC24 from '@/components/text/Chapter006sec24'
 import TEXTCHAPTER006SEC25 from '@/components/text/Chapter006sec25'
 import TEXTCHAPTER006SEC26 from '@/components/text/Chapter006sec26'
 import TEXTCHAPTER006SEC27 from '@/components/text/Chapter006sec27'
 import TEXTCHAPTER006SEC28 from '@/components/text/Chapter006sec28'
 import TEXTCHAPTER006SEC29 from '@/components/text/Chapter006sec29'
 import TEXTCHAPTER006SEC30 from '@/components/text/Chapter006sec30'
 import TEXTCHAPTER006SEC31 from '@/components/text/Chapter006sec31'
 import TEXTCHAPTER006SEC32 from '@/components/text/Chapter006sec32'
 import TEXTCHAPTER006SEC33 from '@/components/text/Chapter006sec33'
 import TEXTCHAPTER006SEC34 from '@/components/text/Chapter006sec34'
 import TEXTCHAPTER006SEC35 from '@/components/text/Chapter006sec35'
 import TEXTCHAPTER006SEC36 from '@/components/text/Chapter006sec36'
 import TEXTCHAPTER006SEC37 from '@/components/text/Chapter006sec37'
 import TEXTCHAPTER006SEC38 from '@/components/text/Chapter006sec38'
 import TEXTCHAPTER006SEC39 from '@/components/text/Chapter006sec39'
 import TEXTCHAPTER006SEC40 from '@/components/text/Chapter006sec40'
 import TEXTCHAPTER006SEC41 from '@/components/text/Chapter006sec41'
 import TEXTCHAPTER006SEC42 from '@/components/text/Chapter006sec42'
 import TEXTCHAPTER006SEC43 from '@/components/text/Chapter006sec43'
 import TEXTCHAPTER006SEC44 from '@/components/text/Chapter006sec44'
 import TEXTCHAPTER006SEC45 from '@/components/text/Chapter006sec45'
 import TEXTCHAPTER006SEC46 from '@/components/text/Chapter006sec46'
 import TEXTCHAPTER006SEC47 from '@/components/text/Chapter006sec47'
 import TEXTCHAPTER006SEC48 from '@/components/text/Chapter006sec48'
 import TEXTCHAPTER006SEC49 from '@/components/text/Chapter006sec49'
 import TEXTCHAPTER007 from '@/components/text/Chapter007'
 import TEXTCHAPTER008 from '@/components/text/Chapter008'
 import LOVE_2 from '@/components/love_2'
 import TEXTAPPENDIXA from '@/components/text/AppendixA'
 import TEXTAPPENDIXB from '@/components/text/AppendixB'
 import TEXTAPPENDIXC from '@/components/text/AppendixC'
 import TEXTRESOURCES from '@/components/text/Resources'
 import TEXTCONVERSIONS from '@/components/text/Conversions'
 import TEXTACKNOWLEDGMENTS from '@/components/text/Acknowledgments'
 import TEXTABOUT_THE_AUTHOR from '@/components/text/About_the_Author'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/text/Contents",
 			"name" : "text/Contents",
 			"component" : TEXTCONTENTS
 		},
 		{
 			"path" : "/text/Introduction",
 			"name" : "text/Introduction",
 			"component" : TEXTINTRODUCTION
 		},
 		{
 			"path" : "/text/Chapter001",
 			"name" : "text/Chapter001",
 			"component" : TEXTCHAPTER001
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js